module.exports = __webpack_public_path__ + "static/media/bannerEsquentaBlackoutLarge.bc548f79.jpg";